import { Download, FileText } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import PtfButton from "@/components/PtfButton";
import { IMAGES } from "@/lib/content";
import { BACKEND_URL } from "@/lib/api";

const TERMS_PDF_URL = `${BACKEND_URL}/api/dawn/terms-pdf`;

export default function DawnTerms() {
  return (
    <>
      <Seo
        title="Terms & Conditions - DAWN: A Project of Belief"
        path="/dawn/terms"
        description="Official Terms & Conditions for DAWN: A Project of Belief."
      />
      <PageHero
        eyebrow="DAWN: A Project of Belief"
        titleLines={["Terms &", "Conditions"]}
        intro="The official terms and conditions governing the DAWN: A Project of Belief selection process. Please read carefully before applying."
        image={IMAGES.forest}
      />
      <section className="mx-auto max-w-[900px] px-5 sm:px-8 py-16 md:py-24" data-testid="dawn-terms-page">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-8 border border-ptf-primary/12 bg-ptf-primary/[0.03] p-5">
          <p className="flex items-center gap-2 text-sm text-ptf-text/70">
            <FileText className="h-4 w-4 text-ptf-secondary shrink-0" />
            Official document, version 1.
          </p>
          <a
            href={TERMS_PDF_URL}
            download="DAWN-A-Project-of-Belief-Terms-and-Conditions.pdf"
            data-testid="dawn-terms-download"
            className="inline-flex items-center gap-2 bg-ptf-primary text-ptf-bg px-6 py-3 text-xs font-semibold uppercase tracking-[0.18em] hover:bg-ptf-secondary transition-colors"
          >
            <Download className="h-3.5 w-3.5" /> Download PDF
          </a>
        </div>
        <div className="border border-ptf-primary/12 bg-white" data-testid="dawn-terms-viewer">
          <iframe
            src={TERMS_PDF_URL}
            title="DAWN: A Project of Belief - Terms & Conditions"
            className="w-full h-[80vh]"
          />
        </div>
        <p className="mt-6 text-xs text-ptf-text/50">
          If the document above does not display in your browser, use the download button to view it directly.
        </p>
        <div className="mt-10">
          <PtfButton to="/dawn/apply">Back to Apply</PtfButton>
        </div>
      </section>
    </>
  );
}
